import UnityBoard from "./UnityBoard";

class Canvas extends UnityBoard {
    constructor() {
        super();
        this.setBoardType("canvas");
    }
}
export default Canvas;